/**
 * Where a notification is allowed to send you.
 *
 * `email_notifications.content_url` holds a RELATIVE app path for notifications
 * that implement the backend's LinksToAppPage contract, and an absolute URL (or
 * nothing) otherwise. The modal routes the first kind through the SPA router
 * and opens the second in a new tab, so it needs to tell them apart.
 */

/**
 * True for a same-app destination the SPA router can handle.
 *
 * "//evil.com" is a protocol-relative URL — it starts with "/" but the browser
 * reads it as "https://evil.com" — so a bare startsWith("/") check would hand
 * an off-site address to the router. The backend refuses to store anything
 * non-relative; this is the second half of that guard, on the side that
 * actually navigates, because rows written before that guard existed still
 * flow through here.
 */
export const isInAppPath = (url: string): boolean =>
  url.startsWith('/') && !url.startsWith('//');
